import { Box, Center, Flex, Grid, Select, Spinner, Text, Badge } from '@chakra-ui/react'
import { HeadingPages } from '../../components/HeadingPages'
import { useEffect, useState, useCallback, useMemo } from 'react'
import React from 'react'
import { FilterBar } from './components/FilterBar'
import { Tabela } from './components/Tabela'
import { useMeusChamados } from './hooks/useMeusChamados'
import { Card } from '../ADM/ChamadosSolicitados/Card'

export function MeusChamados() {
  const [view, setView] = useState('card')
  const [filters, setFilters] = useState({ searchTerm: '', prioridade: '', concluido: '' })

  const { chamados, isLoading } = useMeusChamados({
    prioridade: filters.prioridade,
    concluido: filters.concluido,
  })

  const filteredData = useMemo(() => {
    if (!chamados) return []

    return chamados.filter((item) => {
      const matchesSearchTerm =
        !filters.searchTerm ||
        item.numero_chamado.toString().includes(filters.searchTerm) ||
        item.tipo_chamado?.toLowerCase().includes(filters.searchTerm.toLowerCase()) ||
        (item.detalhes_problema && item.detalhes_problema.toLowerCase().includes(filters.searchTerm.toLowerCase()))

      return matchesSearchTerm
    })
  }, [chamados, filters])

  useEffect(() => {
    document.title = `${filteredData?.length || 0} Meus Chamados | Innovation`
  }, [chamados, filters, filteredData?.length])

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters)
  }, [])

  const setPriorityColor = useCallback((priority) => {
    const priorityColor = {
      Baixa: 'green.500',
      Media: 'yellow.500',
      Alta: 'red.400',
      'Muito alta': 'red.500',
    }

    return priorityColor[priority] || 'gray.500'
  }, [])

  return (
    <>
      <HeadingPages name="Meus Chamados" />

      <FilterBar onFilterChange={handleFilterChange} />

      <Box
        p="4"
        display="flex"
        justifyContent={{ base: 'flex-start', md: 'space-between' }}
        alignItems="start"
        mb="4"
        flexDir={{ base: 'column', md: 'row' }}
        gap={2}
        width="100%"
      >
        <Badge colorScheme="blue" p={2} fontSize="sm" borderRadius="md">
          Total: {filteredData?.length || 0} chamados
        </Badge>

        <Box maxW="300px">
          <Text fontWeight="bold">Visualizar como:</Text>
          <Select onChange={(e) => setView(e.target.value)} mb="4" value={view}>
            <option value="card">Card</option>
            <option value="table">Tabela</option>
          </Select>
        </Box>
      </Box>

      {isLoading && (
        <Center p={8}>
          <Spinner color="blue.500" size="xl" thickness="4px" />
        </Center>
      )}

      {view === 'card' && <CardView data={filteredData} setPriorityColor={setPriorityColor} />}

      {view === 'table' && <Tabela data={filteredData} setPriorityColor={setPriorityColor} />}
    </>
  )
}

const CardView = React.memo(({ data, setPriorityColor }) => {
  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }} gap={4} p={4}>
      {data.map((item) => (
        <Card key={item.numero_chamado} item={item} setPriorityColor={setPriorityColor} isAdminView={false} />
      ))}
    </Grid>
  )
})
